import createDuck from 'lib/ducks/remoteDuck'
import UserInfo from 'lib/api/user-info'

export default createDuck({
  namespace: 'user',
  store: 'userInfo',
  fetchCallback: (option) => UserInfo.handleFetch(option),
})
